import React, { useState, useContext } from "react";
import { AuthenticationContext } from "../../../services/authentication/authentication.context";
import PulseLoader from "react-spinners/PulseLoader";

export const ConfessionResponseForm = ({
  message,
  id,
  setParentMessage,
  setParentId,
}) => {
  const { onUpdatePenance } = useContext(AuthenticationContext);
  const [penance, setPenance] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState("");

  return (
    <form id="confessionResponseForm">
      <h2>Bless me, Father, for I have sinned:</h2>
      <p>{message}</p>
      <label htmlFor="penance">Penance</label>
      <textarea
        id="penance"
        name="penance"
        value={penance}
        onChange={(event) => {
          setPenance(event.target.value);
        }}
      />
      {error && <p style={{ color: "red" }}>{error}</p>}
      {!isSending ? (
        <button
          onClick={async (event) => {
            event.preventDefault();
            if (!id) {
              setError("Please select a confession before submitting penance.");
              return;
            }

            if (penance.length) {
              setIsSending(true);
              setError("");
              try {
                const c = await onUpdatePenance(id, penance);
                setPenance("");
                setParentMessage("none");
                setParentId("");
                setIsSending(false);
              } catch (e) {
                console.log("Update penance error:", e);
                const status = e && e.response && e.response.status;
                if (status === 429) {
                  setError("Too many requests. Please wait a minute and try again.");
                } else if (status === 401) {
                  setError("Your session expired. Please log in again.");
                } else {
                  setError("Failed to submit penance. Please try again.");
                }
                setIsSending(false);
              }
            } else {
              setError("Please enter a penance before submitting.");
            }
          }}
        >
          Send Penance
        </button>
      ) : (
        <PulseLoader
          color={"#295927"}
          loading={isSending}
          size={20}
          speedMultiplier={0.5}
        />
      )}
    </form>
  );
};
